var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31 5H0V26H31V5Z",
    fill: "#C3C7E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.152 16.0927L0 5H31L18.848 16.0927C16.939 17.8356 14.0574 17.8356 12.1484 16.0927H12.152Z",
    fill: "#757FBC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon-mail.add401f3247e16154189e7beb12e3cb0.svg";
export { ForwardRef as ReactComponent };